const templates = {
  need_sync: {
    title: 'Code templates are available after the first sync only',
    description:
      'Synchronise your workspace to unlock the code generation templates feature.',
    run_sync: 'Run the first sync',
  },
  navigation: {
    assets_group_title: 'Assets',
    styles_category_title: 'Styles',
    static_category_title: 'Static',
    variables_category_title: 'Variables',
  },
  file_types: {
    css: '.css (stylesheet)',
    ts: '.ts (TypeScript file)',
    tsx: '.tsx (React TypeScript file)',
    json: '.json (JSON file)',
    svg: '.svg (Scalable Vector Graphic file)',
  },
  buttons: {
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    reset: 'Reset',
  },
  tooltip: {
    delete: 'Delete template',
  },
  template: 'Template:',
  reset_confirmation_modal: {
    new: {
      title: 'Cancel template creation',
      description:
        'Are you sure you want to cancel the creation of a new template? All changes will be lost.',
    },
    edit: {
      title: 'Reset template',
      description:
        'Are you sure you want to reset the template? All changes will be lost.',
    },
  },
  unsaved_changes_modal: {
    title: 'Unsaved changes',
    description: 'You have unsaved changes. Are you sure you want to leave?',
    confirm: 'Continue editing',
    cancel: 'Discard changes',
  },
  labels: {
    name: 'Name',
    file_type: 'Extension',
  },
  settings_modal: {
    title: 'Template properties',
    execution_mode_collection: 'Collection',
    execution_mode_single: 'Single',
  },
  delete_confirmation_modal: {
    title: 'Delete template',
    description:
      'Do you want to delete this template?\nThis action is irreversible, you would not be able to revoke it.',
  },
} as const;

export default templates;
